import React from 'react';

import CtaWithHint from 'components/CtaWithHint';
import LegalPageLayout from 'components/LegalPageLayout';
import LocalizedLink from 'components/LocalizedLink';
import TrustProof from 'components/TrustProof';
import { GUIDE_SLUGS, type GuideSlug } from 'content/marketingRoutes';
import { useI18n } from 'i18n/I18nContext';

const SECTION_NUMS = ['1', '2', '3', '4', '5'] as const;

export interface GuidePageProps {
  slug: GuideSlug;
}

const GuidePage = ({ slug }: GuidePageProps) => {
  const { t } = useI18n();
  const prefix = `guides.${slug}`;
  const minutes = t(`${prefix}.minutes`);

  return (
    <LegalPageLayout
      title={t(`${prefix}.title`)}
      lede={t(`${prefix}.intro`)}
      variant="marketing"
      wide
    >
      <p className="mb-35 text-sm gb-prose-muted">{t('guides.readTime', { minutes })}</p>

      {SECTION_NUMS.map((n) => (
        <section key={n} className="mb-35">
          <h2 className="text-lg font-bold mb-10">{t(`${prefix}.sections.s${n}Title`)}</h2>
          <p className="m-0 gb-prose-muted">{t(`${prefix}.sections.s${n}Body`)}</p>
        </section>
      ))}

      <p className="mb-40 gb-guide-tip">{t(`${prefix}.tip`)}</p>

      <div className="gb-resource-cta mb-50">
        <CtaWithHint href="/onboard" buttonLabel={t('guides.cta')} hint={t('guides.ctaHint')} />
        <TrustProof className="mt-25" />
      </div>

      <p className="mb-15">
        <LocalizedLink className="text-green font-bold no-underline" to="/checklist">
          {t('guides.seeChecklist')}
        </LocalizedLink>
      </p>
      <p className="mb-40">
        <LocalizedLink className="text-green font-bold no-underline" to="/for">
          {t('guides.seeVerticals')}
        </LocalizedLink>
      </p>

      <h2 className="text-lg font-bold mb-15">{t('guides.otherGuides')}</h2>
      <ul className="gb-link-list">
        {GUIDE_SLUGS.filter((item) => item !== slug).map((item) => (
          <li key={item}>
            <LocalizedLink className="text-green font-bold no-underline" to={`/guides/${item}`}>
              {t(`guides.${item}.title`)}
            </LocalizedLink>
          </li>
        ))}
      </ul>
    </LegalPageLayout>
  );
};

export default GuidePage;



// WEBPACK FOOTER //
// ./src/pages/GuidePage.tsx